import React from "react";

import { useIntl } from "react-intl";

import { OPEN_LINK } from "../../../../constants/types/commands";
import { useSendCommand } from "../../../../hooks/use-send-command";
import { ContentCardCaption } from "../../../content-card/caption";
import { ContentCard } from "../../../content-card";

import { Video } from "../../../video";
import { ProviderIcon } from "../../../video/provider-icon";

import styles from "./styles.modules.scss";

const getCaption = (
    author?: string,
    title?: string,
    authorThumbnail?: string,
) => {
    if (!author && !title) {
        return;
    }

    return {
        author,
        title,
        icon: authorThumbnail,
    };
};

export const BlockVideo = ({
    embed,
    embedVideo,
    id,
    thumbnail,
    author,
    title,
    authorThumbnail,
}: InboxArticleVideoBlock) => {
    const sendCommand = useSendCommand();
    const { locale: lang } = useIntl();

    const { url } = embed;
    const caption = getCaption(author, title, authorThumbnail);

    const onClick = () =>
        !embedVideo && sendCommand(OPEN_LINK, { url, label: title });

    return (
        <div className={`block-video ${styles.blockVideo}`} onClick={onClick}>
            <div className={`card ${styles.card}`}>
                <ContentCard id={id} lang={lang}>
                    <div className={`content ${styles.content}`}>
                        <div className={`video ${styles.video}`}>
                            <Video
                                caption={caption}
                                containerId={`video-block-${id}`}
                                embedVideo={embedVideo}
                                embed={embed}
                                thumbnail={thumbnail}
                            />
                        </div>

                        <div className={`caption ${styles.caption}`}>
                            {caption && (
                                <ContentCardCaption
                                    creator={caption.author}
                                    cardId={id}
                                    ctaHidden={true}
                                    icon={caption.icon}
                                    title={caption.title}
                                />
                            )}

                            {embed.provider && (
                                <div className={`provider ${styles.provider} `}>
                                    <ProviderIcon
                                        provider={embed.provider}
                                        variant="small"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </ContentCard>
            </div>
        </div>
    );
};
